import { activityLogs } from './activity-logs.query';
import { conditionTemplate } from './condition-template.query';
import { formStructure } from './form-structure.query';
import { keyImage } from './key-image.query';
import { renderedSummary } from './rendered-summary.query';
import { report } from './report.query';
import { reportFinding } from './report-finding.query';
import { reportIssue } from './report-issue.query';
import { reportOrgan } from './report-organ.query';
import { reportPdf } from './report-pdf.query';
import { reportServiceDeskIssue } from './report-service-desk-issue.query';

export const fct = {
  activityLogs,
  conditionTemplate,
  formStructure,
  keyImage,
  renderedSummary,
  report,
  reportFinding,
  reportIssue,
  reportOrgan,
  reportPdf,
  reportServiceDeskIssue,
};
